import { connect } from 'react-redux';
import PrivacyPolicyConfirmationView from './PrivacyPolicyConfirmationView.jsx';
import { updatePrivacyPolicyControl } from 'src/redux/actions/accounts.ts';
import _ from "lodash";

const mapStateToProps = (state, ownProps) => {
  return {
    updating: _.get(state.accounts, "privacyPolicyControl.updating",false)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updatePrivacyPolicyControl: (privacyPolicyData, consentRequired) => {
      return dispatch(updatePrivacyPolicyControl(privacyPolicyData, consentRequired));
    }
  }
}


const PrivacyPolicyConfirmationPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(PrivacyPolicyConfirmationView);

export default PrivacyPolicyConfirmationPage;